import * as rxjs from 'rxjs'
import * as xlsx from '@e965/xlsx'

export function csv$(file: rxjs.Observable<File | undefined>) {
  return file.pipe(
    rxjs.switchMap(async f => {
      if (!f) {
        return undefined
      }

      const arrayBuffer = await f.arrayBuffer()
      const workbook = xlsx.read(arrayBuffer, {
        type: 'array',
      })

      const result: Record<string, string> = {}

      for (const sheetName of workbook.SheetNames) {
        const sheet = workbook.Sheets[sheetName]
        const data = xlsx.utils.sheet_to_csv(sheet, {
          blankrows: false,
          skipHidden: true,
          strip: true,
        })
        result[sheetName] = data
      }

      return result
    }),
  )
}
